import React, { useEffect, useState } from 'react';
import { Backdrop, Box, Fade, Modal } from "@mui/material";
import { word } from "../word.js";
import BlueButton from "./BlueButton/BlueButton.js";
import { ClipLoader } from "react-spinners";
import Api from "../Api.js";
import Datetime from 'react-datetime';
import moment from 'moment';
import FormMultiSelect from "./EditComponent/FormMultiSelect.js";
import FormDropdown from "./EditComponent/FormDropdown.js";
import FormInput from "./EditComponent/FormInput.js";
import { useDispatch } from "react-redux";
import { updateCompanyRequest } from "../store/actions/companies.js";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.innerWidth > 600 ? 500 : window.innerWidth,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    height: 'auto',
    overflow: 'auto',
    maxHeight: '97vh'
};

function EditCompany({ open, data, setOpen }) {
    const _getValue = (data, key) => {
        let result = data;
        let path = key.split(".")
        for (let index = 0; index < path.length; index++) {
            const element = path[index];
            result = result[element]
        }
        return result === data ? null : result;
    }

    const [form, setForm] = useState([
        {
            key: 'name',
            value: _getValue(data, "name"),
            errorMessage: "empty_error",
            type: "text",
            label: "",
            valid: true
        },
        {
            key: 'HVHH',
            value: _getValue(data, "HVHH"),
            errorMessage: "empty_error",
            type: "text",
            label: "",
            valid: true
        },
        {
            key: 'address',
            value: _getValue(data, "address"),
            errorMessage: "empty_error",
            type: "text",
            label: "",
            valid: true
        },
        {
            key: 'created_number',
            value: _getValue(data, "created_number"),
            errorMessage: "empty_error",
            type: "number",
            label: "",
            valid: true
        },
        {
            key: 'count_employees',
            value: _getValue(data, "count_employees"),
            errorMessage: "empty_error",
            type: "number",
            label: "",
            valid: true
        },
        {
            key: 'director_full_name',
            value: _getValue(data, "director_full_name"),
            errorMessage: "empty_error",
            type: "text",
            label: "",
            valid: true
        },
        {
            key: 'type_of_activity',
            value: _getValue(data, "type_of_activity")?.map(el => ({ value: el?.url, label: el.name })) || [],
            option: "typeActivity",
            errorMessage: "empty_error",
            type: "multiSelect",
            label: "type_of_activity",
            valid: true
        },
        {
            key: 'service',
            value: _getValue(data, "service")?.map(el => ({ value: el?.url, label: el.name })) || [],
            option: "service",
            errorMessage: "empty_error",
            type: "multiSelect",
            label: 'type_of_service',
            valid: _getValue(data, "service").length > 0
        },
        {
            key: 'taxation_system',
            value: _getValue(data, "taxation_system")?.url,
            option: "taxationSystem",
            errorMessage: "select",
            type: "dropDown",
            label: "",
            valid: true
        },
        {
            key: 'packages',
            value: _getValue(data, "packages")?.url,
            option: "card",
            errorMessage: "select",
            type: "dropDown",
            label: "",
            valid: true
        },
        {
            key: 'category',
            value: _getValue(data, "category"),
            option: [
                { id: 1, name: "Գործող" },
                { id: 2, name: "Չգործող" }
            ],
            errorMessage: "select",
            type: "dropDown",
            label: "",
            valid: true
        },
        {
            key: 'agreement_date',
            value: _getValue(data, "agreement_date"),
            option: [],
            errorMessage: "empty_error",
            type: "date",
            label: "",
            valid: _getValue(data, "agreement_date") !== null
        },
        {
            key: 'change_data',
            value: _getValue(data, "change_data"),
            errorMessage: "empty_error",
            type: "text",
            label: "change_data",
            valid: true
        }
    ]);
    const dispatch = useDispatch()
    const [image, setImage] = useState("");
    const [imagePreviewUrl, setImagePreviewUrl] = useState("");
    const [disabled, setDisabled] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [global, setGlobal] = useState({
        activities: [],
        tax: [],
        package: [],
        service: [],
    })

    const handleFileChange = (e) => {
        let reader = new FileReader();
        let file = e.target.files[0] || image;
        reader.onloadend = () => {
            setImage(file);
            setImagePreviewUrl(reader.result);
        };
        if (file) reader.readAsDataURL(file);
    };

    useEffect(() => {
        (async () => {
            try {
                const activity = await Api.activityType();
                const tax = await Api.taxSystem();
                const packages = await Api.packages();
                const service = await Api.companyServices();
                setGlobal({
                    activities: activity.data.results,
                    tax: tax.data.results,
                    package: packages.data.results,
                    service: service.data.results,
                })
            } catch (error) {

            }

        })()
    }, []);

    const changeOrgHandler = async () => {
        const client = data.client?.url;
        const formData = new FormData();

        if (image) {
            formData.append("logo", image);
        }

        setSubmitted(true);
        setDisabled(true);
        formData.append("client", client);

        setForm(prevForm => {
            for (let index = 0; index < prevForm.length - 1; index++) {
                const element = prevForm[index];
                if (!element.valid && element !== "change_data") {
                    setDisabled(false);
                    return prevForm;
                }
                if (element.type === "multiSelect") {
                    element.value.forEach(val => {
                        formData.append(element.key, val.value);
                    });
                } else if (element.type === "date") {
                    formData.append("agreement_date", moment(element.value).format("YYYY-MM-DD"));
                } else {
                    formData.append(element.key, element.value);
                }
            }

            data.accountant.forEach(accountant => {
                formData.append("accountant", accountant?.url);
            });

            formData.append("change_data", prevForm[prevForm.length - 1].value);
            return prevForm;
        });
        await dispatch(updateCompanyRequest(data.id, formData))
        setOpen(false)
    }

    const handleInputChange = (item, date) => {
        setForm((prevForm) => {
            return prevForm.map((formItem) =>
                formItem.key === item.key
                    ? { ...formItem, value: date, valid: !!date }
                    : formItem
            );
        });
    };
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}

        >
            <Fade in={open}>
                <Box sx={style}>
                    <div className="addOrg editOrg">
                        <div className='container flex-column align-items-center'>
                            <div className="close-line">
                                <div className="tool-tip-cont">
                                    <div className="tool-tip">Փակել</div>
                                    <i className="fas fa-times" onClick={() => setOpen(false)} />
                                </div>
                            </div>
                            <div className="add-org-image">
                                <label>
                                    <input className="fileInput" type="file" multiple onChange={handleFileChange} />
                                    <span className='add-span'>{word.add_picture}</span>
                                    <div className='add-round-img'>{imagePreviewUrl || data.logo ?
                                        <img src={imagePreviewUrl || data.logo} alt="preview" /> :
                                        <i className="fas fa-camera" />}</div>
                                </label>
                            </div>
                            {form.map((item, index) => {
                                if (item.type === "multiSelect") return (<FormMultiSelect
                                    key={index}
                                    item={item}
                                    index={index}
                                    global={global}
                                    setForm={setForm}
                                />);

                                if (item.type === "dropDown") return (<FormDropdown
                                    key={index}
                                    item={item}
                                    index={index}
                                    global={global}
                                    setForm={setForm}
                                />);
                                if (item.type === "date") {
                                    return (
                                        <div className="input-section" key={index}>
                                            <input
                                                type="date"
                                                value={item.value ? new Date(item.value).toISOString().substr(0, 10) : ""}
                                                onChange={(e) => handleInputChange(item, e.target.value)}
                                            />
                                            {!item.valid && submitted &&
                                                <div className="validation valid-center">{word[item.errorMessage]}</div>}
                                        </div>
                                    );
                                }
                                return (<FormInput
                                    key={index}
                                    item={item}
                                    index={index}
                                    setForm={setForm}
                                />);
                            })}
                        </div>
                        {disabled &&
                            <div className='loaderMargin'><ClipLoader type="Oval" color="#101C2A" size={30} /></div>}
                        <div className="button-cont">
                            <BlueButton title={word.save} disabled={disabled}
                                buttonStyle={disabled ? "blue-button blue-button-disabled" : "blue-button"}
                                onChangeValue={changeOrgHandler} />
                        </div>

                    </div>
                </Box>
            </Fade>
        </Modal>
    );
}

export default EditCompany;